export default "__VITE_ASSET__BgUXULuM__"